import { cn } from "@/utils"
import { HTMLAttributes, PropsWithChildren } from "react"

interface ITitleProps extends HTMLAttributes<HTMLElement> {
  variant: "body1" | "body2" | "title"
  className?: string
}
export const Title = ({ className, variant, children }: ITitleProps & PropsWithChildren) => {
  const variantClass = {
    body1: "text-sm font-bold text-black",
    body2: "text-base font-bold text-black",
    title: "text-xs font-bold text-[#777E8A]",
  }
  return <span className={cn("inline-block", variantClass[variant], className)}>{children}</span>
}
